export var EApplicationStatus;
(function (EApplicationStatus) {
    EApplicationStatus["QC_PENDING"] = "QC Pending";
    EApplicationStatus["QC_APPROVED"] = "QC Approved";
    EApplicationStatus["QC_REJECTED"] = "QC Rejected";
    EApplicationStatus["IBEASTS_FAILED"] = "IBeats Failed";
    EApplicationStatus["IBEASTS_SUCCESS"] = "IBeats Success";
    EApplicationStatus["ACTIVE_FOR_TRADE"] = "Active for Trade";
    EApplicationStatus["ACTIVE_FOR_TRADE_FAILED"] = "Active for trade (failed)";
})(EApplicationStatus || (EApplicationStatus = {}));
